import { FC } from "react";
import { Button } from "@mui/material";
import styled from "@emotion/styled";
import { AuthService, SocialLoginType } from "@service/auth.service";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useNavigate } from "react-router-dom";
import { ReactComponent as AppleIcon } from "../../../../public/icons/apple-icon.svg";
import { ReactComponent as FacebookIcon } from "../../../../public/icons/facebook-icon.svg";
import { ReactComponent as GoogleIcon } from "../../../../public/icons/google-icon.svg";

const Buttons = styled.div`
  display: flex;
  margin-top: 40px;
  margin-bottom: 40px;
  gap: 16px;
  justify-content: center;
  width: 100%;
`;

const SocialButton = styled(Button)`
  width: 127px;
  height: 42px;
  border-color: #c1c9da;
  border-radius: 8px;
`;

const authService = AuthService.instance;

const SocialSignIn: FC<{ onSignInClick?: () => void }> = ({
  onSignInClick,
}) => {
  const isLoggedIn = useSelector(
    (state: RootState) => state.auth.user !== null,
  );
  const navigate = useNavigate();

  const signInSocial = async (type: SocialLoginType) => {
    onSignInClick?.();
    if (isLoggedIn) {
      navigate("/");
      return;
    }

    await authService.signInSocial(type);
  };

  return (
    <>
      <Buttons>
        <SocialButton variant="outlined" onClick={() => signInSocial("Apple")}>
          <AppleIcon />
        </SocialButton>
        <SocialButton
          variant="outlined"
          onClick={() => signInSocial("Facebook")}
        >
          <FacebookIcon />
        </SocialButton>
        <SocialButton variant="outlined" onClick={() => signInSocial("Google")}>
          <GoogleIcon />
        </SocialButton>
      </Buttons>
    </>
  );
};

export default SocialSignIn;
